<template>
    <div>
        <b-loading :active="loading"></b-loading>
        <div v-if="!loading">
            <div class="section">
                <h1 class="title is-uppercase" v-text="product.name"></h1>
            </div>

            <div class="section">
                <div class="tile is-ancestor">
                    <div class="tile is-parent">
                        <div class="tile is-child box">
                            <p class="subtitle">Informations</p>
                            <table class="table is-narrow is-fullwidth">
                                <tr>
                                    <td>Product Name</td>
                                    <td class="has-text-weight-bold" v-text="product.name"></td>
                                </tr>
                                <tr>
                                    <td>Modello</td>
                                    <td class="has-text-weight-bold" v-text="product.model"></td>
                                </tr>
                                <tr>
                                    <td>Variante</td>
                                    <td class="has-text-weight-bold" v-text="product.variant"></td>
                                </tr>
                                <tr>
                                    <td>Season</td>
                                    <td class="has-text-weight-bold" v-text="product.season.name"></td>
                                </tr>
                                <tr>
                                    <td>Collection</td>
                                    <td class="has-text-weight-bold" v-text="product.collection"></td>
                                </tr>
                                <tr>
                                    <td>SKU</td>
                                    <td class="has-text-weight-bold" v-text="product.code"></td>
                                </tr>
                                <tr>
                                    <td>In Stock?</td>
                                    <td class="has-text-weight-bold"
                                        v-text="product.in_stock ? 'In Stock' : 'Out of Stock'"></td>
                                </tr>
                                <tr>
                                    <td>Brand</td>
                                    <td class="has-text-weight-bold" v-text="product.brand.name"></td>
                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    <td class="has-text-weight-bold" v-text="product.gender.name"></td>
                                </tr>
                                <tr>
                                    <td>Category</td>
                                    <td class="has-text-weight-bold" v-text="product.category.name"></td>
                                </tr>
                                <tr>
                                    <td>Parent Category</td>
                                    <td class="has-text-weight-bold" v-text="product.parent_category.name"></td>
                                </tr>
                                <tr>
                                    <td>Sub Parent Category</td>
                                    <td class="has-text-weight-bold" v-text="product.sub_category.name"></td>
                                </tr>
                                <tr>
                                    <td>ID Atelier</td>
                                    <td class="has-text-weight-bold" v-text="product.atelier_id"></td>
                                </tr>
                                <tr>
                                    <td>Created</td>
                                    <td class="has-text-weight-bold" v-text="createdAt.format('DD-MM-YYYY')"></td>
                                </tr>
                                <tr>
                                    <td>Modified</td>
                                    <td class="has-text-weight-bold" v-text="updatedAt.format('DD-MM-YYYY')"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="tile is-parent">
                        <div class="tile is-child box">
                            <p class="subtitle">Meta Data</p>
                            <table class="table is-narrow is-fullwidth">
                                <tr>
                                    <td>Super Color</td>
                                    <td class="has-text-weight-bold" v-text="meta.super_color"></td>
                                </tr>
                                <tr>
                                    <td>Color Name</td>
                                    <td class="has-text-weight-bold" v-text="meta.color_name"></td>
                                </tr>
                                <tr>
                                    <td>Fabric</td>
                                    <td class="has-text-weight-bold" v-text="meta.fabric"></td>
                                </tr>
                                <tr>
                                    <td>Composition</td>
                                    <td class="has-text-weight-bold" v-text="meta.composition"></td>
                                </tr>
                                <tr>
                                    <td>Size</td>
                                    <td class="has-text-weight-bold" v-text="meta.size_and_fit"></td>
                                </tr>
                                <tr>
                                    <td>Made in Country</td>
                                    <td class="has-text-weight-bold" v-text="meta.made_in"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="prices.length" class="section">
                <h3 class="subtitle">Product Price List</h3>
                <b-table :data="prices" striped bordered>
                    <b-table-column field="retailer" label="Retailer" v-slot="props">
                        {{ props.row.retailer.name }}
                    </b-table-column>

                    <b-table-column field="brand_final_price" label="Brand Gross Price" v-slot="props">
                        {{ formatCurrency(props.row.brand_final_price, props.row.currency) }}
                    </b-table-column>

                    <b-table-column field="brand_net_price" label="Brand Net Price" v-slot="props">
                        {{ formatCurrency(props.row.brand_net_price, props.row.currency) }}
                    </b-table-column>

                    <b-table-column field="discount" label="Discount" v-slot="props">
                        {{ formatCurrency(props.row.discount, props.row.currency) }}
                    </b-table-column>

                    <b-table-column field="net_price" label="Net Price" v-slot="props">
                        {{ formatCurrency(props.row.net_price, props.row.currency) }}
                    </b-table-column>

                    <b-table-column field="taxes" label="Taxes" v-slot="props">
                        {{ props.row.tax }}%
                    </b-table-column>
                </b-table>
            </div>

            <div v-if="stock.length" class="section">
                <h3 class="subtitle">Stock Items</h3>
                <b-table :data="stock" striped bordered>
                    <b-table-column field="barcode" label="Barcode" v-slot="props">
                        {{ props.row.barcode }}
                    </b-table-column>

                    <b-table-column field="size" label="Size" v-slot="props">
                        {{ props.row.size }}
                    </b-table-column>

                    <b-table-column field="quantity" label="Quantity" v-slot="props">
                        {{ props.row.quantity }}
                    </b-table-column>


                    <b-table-column field="retailer" label="Retailer" v-slot="props">
                        {{ props.row.retailer_point.retailer.name }}
                    </b-table-column>
                </b-table>
            </div>

            <div class="section">
                <h3 class="subtitle">Product Price History</h3>
                <product-price-history></product-price-history>
            </div>

            <div class="section">
                <h3 class="subtitle">Stock Item History</h3>
                <product-stock-history></product-stock-history>
            </div>


            <div class="section">
                <h3 class="subtitle">Media Gallery</h3>
                <div class="product-image-carousel">
                    <b-carousel-list :data="images" :items-to-show="5" arrow arrow-hover :repeat="false"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import ProductStockHistory from "./ProductStockHistory";
import ProductPriceHistory from "./ProductPriceHistory";

export default {
    components: {ProductStockHistory, ProductPriceHistory},
    data() {
        return {
            product: {},
            meta: {},
            media: [],
            prices: [],
            stock: [],
            loading: true
        }
    },
    mounted() {
        axios.get('/product/show/' + this.$route.params.id)
            .then(response => {
                this.product = response.data.product;
                this.meta = response.data.meta;
                this.media = response.data.media;
                this.prices = response.data.prices;
                this.stock = response.data.stock;
                this.loading = false;
            })
    },
    methods: {
        formatCurrency(price, currency) {
            return new Intl.NumberFormat('it-IT', {style: 'currency', currency: currency}).format(price)
        }
    },
    computed: {
        images() {
            return _.map(this.media, mediaItem => {
                return {image: mediaItem.url}
            })
        },
        createdAt() {
            return moment(this.product.created_at)
        },
        updatedAt() {
            return moment(this.product.updated_at)
        }
    }
}
</script>
